module.exports = __webpack_public_path__ + "assets/img/invite-bacik.90b51e7d.png";